import react, { useState } from "react";

const SwitchInline = ({ label = "", value = "", className = "", readonly = false, errors = [], onChangeEvent, ...props }) => {
    const [randForId] = useState("field-" + Math.random().toString(36).substr(2, 9));

    const hasError = !errors[props.name] ? "" : "is-invalid"
    const ErrorDialog = () => {
        return !errors[props.name] ? <></> :
            (
                <div className="invalid-feedback">
                    {errors[props.name][0]}
                </div>
            )
    }

    const handleOnchange = (e) => {


        onChangeEvent({
            target: {
                name: props.name,
                value: value === null ? 0 : !value
            }
        })
    }


    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <label className="switch switch-inline" style={{ marginVottom: 0, lineHeight: '12px' }}>
                <input
                    type="checkbox"
                    id={randForId}
                    aria-label="test"
                    className={`${className} ${hasError}`}
                    value={value === null ? 0 : value}
                    checked={value === null ? 0 : value}
                    onChange={(e) => handleOnchange(e)}
                    {...props}
                />
                <div className="slider slider-inline"></div>
            </label>
            {label && (
                <label htmlFor={randForId} className="form-label">
                    {label}
                </label>
            )}
            <ErrorDialog />
        </div>

    )
}

export default SwitchInline;